// ng build -c dev

export const environment = {
  production: true,
  googleAnalytics: {
    enabled: true
  },
  suiteTokenMock: null,
  urlFeedbackPortal: 'https://portal.productboard.com/348iht4h18ff4pavvsdzrxtq',
  // Envelopes a batch signs at the same time (1 = one after the other).
  signingParallelEnvelopes: 3
};
